import React from 'react';
import BreadcrumbDesigning from '../BreadcrumbDesigning';
import CardsServices from 'src/views/SoftwareEngineering/components/CardsServices';
import { cardDataWebDesigning } from 'src/shared/utils/string';
import FooterServices from 'src/views/SoftwareEngineering/components/FooterServices';
import Footer from 'src/components/footer';
import './style.scss';
import { Link } from 'react-router-dom';

const WebDesigning = () => {
  return (
    <div className="page-container-web-designing">
        <div className='image-container'>
          <div className='text-container drop-in-2'>
            <h1 className='heading'>Web Designing</h1>
          </div>
            <Link to="/web-designing" className='no-decoration'><BreadcrumbDesigning text={"Web Designing"} /></Link>  
            <div className='red-bg-box'></div>
        </div>

        <CardsServices cardDataServices={cardDataWebDesigning} />
        <FooterServices />
        <Footer />
    </div>
  )
}

export default WebDesigning